module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Piotr_Zuzanna.4b23d5fd.jpg";